import ArbitrageProposalBanner from '@/components/ArbitrageProposalBanner/ArbitrageProposalBanner';
import { useArbitrages } from '@/hooks/useArbitrages';

const useArbitrageSlides = () => {
  const { data: arbitrageProposals, isLoading: isArbitrageProposalsLoading } = useArbitrages();

  const arbitrageSlides = (Array.isArray(arbitrageProposals) ? arbitrageProposals : []).map((proposal, index) => ({
    id: `arbitrage-slide-${index}`,
    content: <ArbitrageProposalBanner proposals={[proposal]} />,
  }));

  return { arbitrageSlides, isArbitrageProposalsLoading };
};

export default useArbitrageSlides;
